import _JSON$stringify from "@babel/runtime-corejs3/core-js-stable/json/stringify";

/**
 * Get display name of a react component with definable fallback
 * @param  {class} Component
 * @param  {String} fallback
 * @return {String}
 */
export function getDisplayName(Component) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Component';
  return Component.displayName || Component.name || fallback;
}
/**
 * Stringify incl. functions
 * @param  {Object} obj
 * @return {String}
 */

export function strongerStringify(obj) {
  return _JSON$stringify(obj, function (key, val) {
    return typeof val === 'function' ? val.toString() : val;
  });
}
/**
 * Deep equal using `strongerStringify`
 * NOTE: this should not be used in any prod code and will be removed
 * eventually!
 * @param  {Object} obj1
 * @param  {Object} obj2
 */

export function strongerEquals(obj1, obj2) {
  var result;

  try {
    result = strongerStringify(obj1) === strongerStringify(obj2);
  } catch (e) {
    result = false;
  }

  return result;
}